import {
    Box,
    Button,
    Heading,
    VStack,
    Text,
    Link,
    Divider,
    Input,
    HStack,
    InputRightElement,
    Icon,
    InputGroup,
    Spinner,
    Center,
} from "@chakra-ui/react";
import Checkout from "../../payment/Checkout";
import { useState } from "react";
import { parseCurrencyToDouble } from "../../../utils/helpers";
import {CURRENCY_SYMBOLS} from "../../../constants";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck} from "@fortawesome/free-solid-svg-icons/faCheck";
import {CheckIcon, CloseIcon} from "@chakra-ui/icons";
import { getPromoCode } from "../../../services/affiliate"
import { getBooking, patchPromoOrder } from "../../../services/bookings";
import { Link as RouterLink, useMatch } from "react-router-dom";
import {useQuery} from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

function BookingConfirmationStep({
  prevStep,
  nextStep,
  activeStep,
  totalPrice,
  isAffiliateCheckout,
}) {
  const { t } = useTranslation("common");

  let qurrencySymbol = "";
  if (localStorage.getItem("currencyCode") === null)
    qurrencySymbol = CURRENCY_SYMBOLS["eu"];

  for (const code in CURRENCY_SYMBOLS) {
    if (code === localStorage.getItem("currencyCode")) {
      qurrencySymbol = CURRENCY_SYMBOLS[code];
      break;
    }
  }

  const match = useMatch("/book/:bookingId");
  const bookingId = match?.params.bookingId;

  const [showPrevButton, setShowPrevButton] = useState(true);
  const showPreviousButton = (isVisible) => {
    setShowPrevButton(isVisible);
  };
  const [promoCode, setPromoCode] = useState({
    promo_code_name: "",
  });
const [promoCodeCorrect, setPromoCodeCorrect] = useState(false)
  const handleInputChange = (e) => {
  if(e.target.value.length === 0) setPromoCode(null)
    setPromoCode((prevState) => ({
      ...prevState,
      promo_code_name: e.target.value,
    }));
  };

  const [applyBtnClicked, setApplyBtnClicked] = useState(false);

    const { data, refetch: refetchBooking, isLoading } = useQuery(
        ["booking-unique", bookingId],
        () => {
            return getBooking(bookingId);
        },
        {
            select: (data) => data.data,
            onSuccess: () => {},
            onError: () => {},
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            refetchOnMount: false,
            enabled: !!bookingId,
        }
    );

    return (
      <>
        {isLoading ? (
                <Box pos="absolute" inset="0" bg="blackAlpha.600" style={{ backdropFilter: 'blur(8px)' }}>
                  <Center h="full">
                    <Spinner color="teal.500" thickness="6px" speed="0.65s" size="xl" />
                  </Center>
                </Box>
            ) : isAffiliateCheckout ? (
                <Box border="1px" borderColor="gray.200" borderRadius="lg" padding="15px">
                  <Text fontSize="sm">{t("bookingAffiliateCheckoutRedirect")}</Text>
                </Box>
            ) : (() => {
                const isPromoApplied = promoCodeCorrect || Boolean(data.promoCode);
                return (
                <Box border="1px" borderColor="gray.200" borderRadius="lg" padding="15px">
                  <VStack align="flex-start" spacing={2}>
                    {!data.promoCode && !data.paypalAuthorizationId && (
                        <>
                          <Text fontSize="xs">
                            {t("bookingPromoCodeHint")}
                          </Text>
                          <HStack align="flex-start" spacing={2}>
                            <InputGroup>
                              <Input
                                  placeholder={t("bookingEnterPromoCode")}
                                  value={promoCode.promo_code_name}
                                  onChange={(e) => {
                                    handleInputChange(e);
                                    setApplyBtnClicked(false); // reset validation state when typing
                                  }}
                                  maxLength={20}
                              />
                              <InputRightElement pointerEvents="none">
                                {!promoCode.promo_code_name ? (
                                    <Icon viewBox="0 0 200 200" boxSize={5}>
                                      <circle cx="100" cy="100" r="75" fill="teal" />
                                    </Icon>
                                ) : applyBtnClicked ? (
                                    promoCodeCorrect ? (
                                        <CheckIcon color="green.500" />
                                    ) : (
                                        <CloseIcon color="red.500" />
                                    )
                                ) : (
                                    <Icon viewBox="0 0 200 200" boxSize={5}>
                                      <circle cx="100" cy="100" r="75" fill="teal" />
                                    </Icon>
                                )}
                              </InputRightElement>
                            </InputGroup>
                            <Button
                                color="white"
                                backgroundColor="teal"
                                onClick={() => {
                                  setApplyBtnClicked(true);
                                  getPromoCode(promoCode.promo_code_name)
                                      .then((response) => {
                                        patchPromoOrder(bookingId, response.data.id, promoCode.promo_code_name).then((response) => {
                                          refetchBooking();
                                        });
                                        setPromoCodeCorrect(true);
                                      })
                                      .catch((err) => {
                                        setPromoCodeCorrect(false);
                                        alert(`${promoCode.promo_code_name} code is wrong or not active!`);
                                      });
                                }}
                            >
                              {t("bookingApply")}
                            </Button>
                          </HStack>
                        </>
                    )}

                    {isPromoApplied && (
                        <HStack>
                          <Text fontSize="2xs" color="grey">
                            {t("bookingDiscountApplied")}
                          </Text>
                          <FontAwesomeIcon icon={faCheck} style={{ color: '#63E6BE' }} />
                        </HStack>
                    )}

                    <Heading as="h3" size="sm">
                      {t("bookingFinishReservation")}
                    </Heading>
                    <Text fontSize="xs">
                      {t("bookingPaymentAuthorization")}
                    </Text>
                    <VStack align="flex-start" spacing={2}>
                      <Text fontSize="sm">
                        {t("bookingTotalAmount")}{' '}
                        {isPromoApplied ? (
                            <>
                              <Text as="s" color="gray.500" mr={2} display="inline">
                                {`${qurrencySymbol} ${parseCurrencyToDouble(data.fullPrice).toFixed(2)}`}
                              </Text>
                              <Text as="span" fontWeight="bold">
                                {parseCurrencyToDouble(data.discountPrice).toFixed(2)}
                              </Text>
                            </>
                        ) : (
                            <Text as="span" fontWeight="bold">
                              {parseCurrencyToDouble(data.fullPrice).toFixed(2)}
                            </Text>
                        )}
                      </Text>
                      <Text fontSize="sm">
                        {t("bookingAdvancePayment")}{' '}
                        <strong>{`${parseCurrencyToDouble(data.deposit).toFixed(2)}`}</strong>
                      </Text>
                      <Text fontSize="sm">
                        {t("bookingRestToPay")}{' '}
                        <strong>
                          {isPromoApplied
                              ? `${qurrencySymbol} ${(
                                  parseCurrencyToDouble(data.discountPrice) - parseCurrencyToDouble(data.deposit)
                              ).toFixed(2)}`
                              : `${qurrencySymbol} ${(
                                  parseCurrencyToDouble(data.fullPrice) - parseCurrencyToDouble(data.deposit)
                              ).toFixed(2)}`}
                        </strong>
                      </Text>
                      <Divider />
                      <Text fontSize="sm">
                        {t("bookingDueNow")} <strong>{`${qurrencySymbol} ${parseCurrencyToDouble(data.deposit).toFixed(2)}`}</strong>
                      </Text>
                    </VStack>
                      {data.paypalAuthorizationId ? <div>paid via paypal</div> :
                    <Checkout
                      showPreviousButton={showPreviousButton}
                    />
                      }
                    {showPrevButton && (
                        <VStack align="flex-start" spacing={2}>
                          <Text fontSize="2xs" color="grey">
                            {t("bookingAgreeTerms")}{' '}
                            <Link
                                as={RouterLink}
                                textDecor="underline"
                                to="/terms_of_use"
                            >
                              {t("bookingTermsOfUse")}
                            </Link>{' '}
                            {t("bookingAnd")}{' '}
                            <Link
                                as={RouterLink}
                                textDecor="underline"
                                to="/privacy_policy"
                            >
                              {t("bookingPrivacyPolicy")}
                            </Link>
                          </Text>
                          <Button colorScheme="blue" size="sm" onClick={prevStep}>
                            {t("bookingPrevious")}
                          </Button>
                        </VStack>
                    )}
                  </VStack>
                </Box>
                );
            })()}
      </>
  );
}

export default BookingConfirmationStep;